module.exports = __webpack_public_path__ + "img/info.cd42aa7e.png";